import React from 'react';
import { View, Text, Image, Alert } from 'react-native';
import { withRouter } from "react-router-dom";
import moment from 'moment';

import {Button, CardTextArrow, Spacing} from "../../../components";
import Colors from "../../../constants/Colors";
import LikeIndicator from "../../mural/components/LikeIndicator";
import {ADD_LIKE, GET_USER_LIKE, REMOVE_LIKE} from "../api/forumEndpoints";
import UtilityBar from "../../content/previews/UtilityBar";

const TopicPostRender = (props) => {

    const userNickname = props.createdBy;
    const createdAt = props.createdAt;
    const text = props.description;
    const answerToData = props.answerToData;

    const responseClick = props.responseClick;

    const isLast = props.isLast;
    const borderBottomWidth = isLast === true ? 0.4 : 0.0

    return (
        <View style={{ borderWidth: 0.4, borderBottomWidth: borderBottomWidth, padding: 18, borderColor: 'gray' }}>
            <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                <View style={{ flexDirection: 'row', width: '90%' }}>

                    {
                        props.isSolution === true &&
                        <Image
                            source={require('../../journeyStack/timeline/icons/checkIcon.png')}
                            style={{ height: 22, width: 22, marginRight: 8 }}
                            resizeMode={'contain'}
                        />
                    }

                    <Text style={{ fontSize: 18, color: Colors.fontColorOnBackground }}>
                        {`${userNickname}`}
                    </Text>

                    <Text style={{ marginLeft: 8, fontSize: 14, color: Colors.fontColorOnBackground }}>
                        { `${moment(createdAt).format('DD/MM/YYYY - HH:mm:ss')}`}
                    </Text>
                </View>

            </View>

            <Spacing height={8} />

            {
                (answerToData !== undefined && answerToData !== null) &&
                    <View style={{ margin: 12, borderWidth: 0.4, borderColor: 'gray', padding: 8, borderRadius: 8 }}>
                        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                            <Text style={{ fontSize: 14, color: Colors.fontColorOnBackground }}>
                                {`${answerToData.createdBy}`}
                            </Text>

                            <Text style={{ marginLeft: 8, fontSize: 12, color: Colors.fontColorOnBackground }}>
                                { `${moment(answerToData.createdAt).format('DD/MM/YYYY - HH:mm:ss')}`}
                            </Text>
                        </View>

                        <Text style={{ color: Colors.fontColorOnBackground }}>
                            { `${answerToData.text}` }
                        </Text>
                    </View>
            }

            <Text style={{ fontSize: 18, color: Colors.fontColorOnBackground }}>
                { text }
            </Text>

            <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', marginTop: 12 }}>

                <LikeIndicator
                    endpointToCheckForLike={GET_USER_LIKE(props.postId, props.currentUserId)}
                    endpointToSendLike={ADD_LIKE}
                    payloadToAddLike={{
                        topicId: props.topicId,
                        postId: props.postId,
                        userId: props.currentUserId
                    }}
                    endpointToRemoveLike={REMOVE_LIKE}
                    payloadToRemoveLike={{
                        topicId: props.topicId,
                        postId: props.postId,
                        userId: props.currentUserId
                    }}
                    numberOfLikes={props.numberOfLikes}
                />

                {
                    responseClick !== undefined &&
                    <Button
                        text={'Responder'}
                        onPress={() => responseClick(props.data)}
                        containerPropsStyle={{ marginLeft: 32, height: 30, width: 160, padding: 4, borderRadius: 8, backgroundColor: Colors.tabBar, alignSelf: 'flex-end' }}
                        textPropsStyle={{ fontSize: 16, fontWeight: 'bold' }}
                    />
                }

                {
                    (props.userCreatedTopic === true && props.isSolution === false && isLast === false) &&
                        <Button
                            text={"Marcar Solução"}
                            onPress={() => props.handleMarkSolution(props.postId)}
                            containerPropsStyle={{ marginLeft: 32, height: 30, width: 160, padding: 4, borderRadius: 8, backgroundColor: Colors.tabBar, alignSelf: 'flex-end' }}
                            textPropsStyle={{ fontSize: 16, fontWeight: 'bold' }}
                        />
                }
            </View>



            {
                (props.currentUserId === props.createdBy) &&
                    <View style={{ padding: 8, width: '100%', marginTop: 12 }}>
                        <UtilityBar
                            onEdit={() => props.history.push('/forum/topic/answer/edit', {
                                postData: {
                                    topicId: props.topicId,
                                    postId: props.postId,
                                    text: text,
                                    answerToPost: answerToData,
                                }
                            })}
                            onRemove={ isLast === false ? () => props.initiateDeleteRequest(props.postId) : null}
                        />
                    </View>
            }







        </View>
    )
}

export default withRouter(TopicPostRender);
